import Vue from 'vue'
import VueRouter from 'vue-router'
import {LoginRoutes, ParantionEventBus, useVariableStore} from '@parantion/components'
// @ts-ignore
import logo from './assets/easion_logo_temp.svg'
// @ts-ignore
import bg from './assets/background.png'
// @ts-ignore
import packageJson from '../package.json'
import api from './services/api'
import {Notify} from 'quasar'
import store from './store/index.js'

Vue.use(VueRouter)
const adminRoles = ['survey_admin']
const managerRoles = ['overall_manager', 'overall_usermanager', 'survey_admin']
const moderatorRoles = ['survey_moderator']
const fileManagerRoles = ['overall_filemanager', 'overall_admin']

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Layout',
      redirect: '/login',
      meta: {
        requiresAuth: true // Authentication works for children as well
      },
      component: () => import('./pages/Layout.vue'),
      children: [
        {
          path: 'surveys',
          name: 'Home',
          component: () => import('./components/Home.vue'),
          meta: {shouldBeModerator: true},
          beforeEnter: (to, from, next) => {
            if (hasPermission(null, moderatorRoles)) next()
            else next(from.fullPath)
          }
        },
        {
          path: 'info',
          name: 'Info',
          component: () => import('./components/Info.vue')
        },
        {
          path: 'about',
          name: 'About',
          component: () => import('./components/About.vue')
        },
        {
          path: 'survey-store',
          name: 'Store',
          component: () => import('./components/Store.vue'),
          meta: {shouldBeModerator: true},
          beforeEnter: (to, from, next) => {
            if (store.state.parantion.user.config.is_survey_store){
              next()
            } else {
              next('/surveys')
            }
          }
        },
        {
          path: 'question-library',
          name: 'ItemBank',
          component: () => import('./pages/ItemBank.vue'),
          meta: {shouldBeProUser: true, shouldBeAdmin: true}
        },
        {
          path: 'file-management',
          name: 'FileManagement',
          component: () => import('./components/FileManagement.vue'),
          meta: {shouldBeFileManager: true},
          beforeEnter: (to, from, next) => {
            if (hasPermission(null, fileManagerRoles)) next()
            else next(from.fullPath)
          }
        },
        {
          path: 'surveys/details/:surveyHash',
          name: 'SurveyDetails',
          component: () => import('./components/survey/SurveyDetails.vue'),
          meta: {shouldBeModerator: true},
          beforeEnter: (to, from, next) => {
            if (hasPermission(null, moderatorRoles)) next()
            else next(from.fullPath)
          }
        },
        {
          path: 'user-management',
          name: 'UserManagement',
          component: () => import('./pages/UserManagement.vue'),
          meta: {shouldBeManager: true},
          beforeEnter: (to, from, next) => {
            if (hasPermission(null, managerRoles)) next()
            else next(from.fullPath)
          }
        }
      ]
    },
    {
      path: '/review',
      name: 'Review',
      meta: {
        requiresAuth: false // Authentication works for children as well
      },
      component: () => import('./pages/FormReview.vue'),
    },
    LoginRoutes({
      logo: logo,
      tfa: true,
      backgroundImage: bg,
      justifyCenter: true,
      version: packageJson.version,
      versionName: packageJson.versionName,
      tenantName: packageJson.name,
      emailSubject: 'Wachtwoord wijziging Easion',
      emailTheme: 'easion',
      onLogin: user => {
        onLogin()
        if (hasPermission(user.role, moderatorRoles)) {
          api.defaultService.setToken(user.token)
          router.push('/surveys')
        } else if (hasPermission(user.role, adminRoles)) {
          api.defaultService.setToken(user.token)
          router.push('/user-management')
        } else if (hasPermission(user.role, managerRoles)) {
          api.defaultService.setToken(user.token)
          router.push('/user-management')
        } else {
          Notify.create({
            message: 'Dit account geeft geen toegang tot Easion Survey. | This account has no access to Easion Survey.',
            icon: 'block',
            textColor: 'white'
          })
          logOut()
        }
      },
      onLogout: user => {
        logOut()
      }
    }, this),
    {path: '*', redirect: '/login'}
  ]
})

/**
 * This function checks the roles of the user and the roles it should have.
 * Returns a boolean.
 * @param currentRoles
 * @param rolesItShouldHave
 */
function hasPermission (currentRoles: Array<any>, rolesItShouldHave: Array<any>) {
  let isAllowed = false

  if (currentRoles) {
    for (let role of currentRoles) {
      if (rolesItShouldHave.includes(role)) {
        isAllowed = true
        break
      }
    }
  } else {
    try {
      const timeStamp = sessionStorage.getItem('store_timestamp')
      const vuex = sessionStorage.getItem(`easionx-ts:${timeStamp}-vx`)
      const roles = JSON.parse(vuex).parantion.user.roles
      for (let role of roles) {
        if (rolesItShouldHave.includes(role)) {
          isAllowed = true
          break
        }
      }
    } catch (e) { // sessionStorage is probably empty at this point
      isAllowed = false
    }
  }
  return isAllowed
}

/**
 * This function empties the session store and redirects user to the login page.
 */
function logOut () {
  const timeStamp = sessionStorage.getItem('store_timestamp')
  sessionStorage.removeItem(`easionx-ts:${timeStamp}-vx`)
  router.push('/login').catch(e => e)
}

function onLogin () {
  // make sure the variableStore is initialized
  useVariableStore()
  // TODO this can go away when the new itembank is here

  setTimeout(async () => {

    store.dispatch('parantion/items/getQuestionItems')
    store.dispatch('parantion/items/getOptionGroups')
  }, 3000)


  // @ts-ignore
  ParantionEventBus.on('logout', () => {
    logOut()
  })
}

/**
 * Function retrieves from the session store the token of the user.
 */
function getStoreToken () {
  try {
    const timeStamp = sessionStorage.getItem('store_timestamp')
    const vuex = sessionStorage.getItem(`easionx-ts:${timeStamp}-vx`)
    return JSON.parse(vuex).parantion.user.token
  } catch (e) {
    // no store or no token
    return null
  }
}

export default router

